import * as React from "react";
import { ReadItemFieldRenderer } from "../Interfaces/readItemFieldRenderer";
import { ItemValue } from "../Components/ItemValue";

export const readItemFieldRenderer: ReadItemFieldRenderer = (props) => {
  return <ItemValue value={props.value} />;
};
